import { useState, useEffect } from "react";

export const useGoogleOptimize = (experimentId: string) => {
  const [variant, setVariant] = useState<string>();
  useEffect(() => {
    (() => {
      const intervalId = setInterval(() => {
        if (window.google_optimize !== undefined) {
          setVariant(window.google_optimize.get(experimentId));
          clearInterval(intervalId);
        }
      }, 100);
    })();
  });
  return variant;
};
